import React from 'react';
import { Icon } from '@chakra-ui/react';
import { BsFillHeartFill, BsHeart } from 'react-icons/all';
import { Token } from '@chakra-ui/styled-system/dist/types/utils';
import * as CSS from 'csstype';
import { ExtendedDetailsRoute } from '../../../types/RoutesTypes';
import { ObjectsParams } from '../../../types/ParamsTypes';

interface ObjectListItemBookmarkProps {
  size: Token<CSS.Property.FontSize | number, 'fontSizes'>;
  objectUniqueId: String;
  bookmarks: Array<ExtendedDetailsRoute>;
  handleBookmarkChange: Function;
  bookmarkContext?: String;
  bookmarkParams?: ExtendedDetailsRoute;
}

export const Bookmark = (props: ObjectListItemBookmarkProps): JSX.Element => {
  const { objectUniqueId, bookmarks, handleBookmarkChange, size, bookmarkParams } = props;
  const isObjectBookmark = bookmarks.find(bookmark => bookmark.id === objectUniqueId);

  const bookmarkContextView = isObjectBookmark ? (
    <Icon
      as={BsFillHeartFill}
      color={'red.400'}
      fontSize={size}
      onClick={() => handleBookmarkChange(bookmarkParams)}
      cursor={'pointer'}
    />
  ) : (
    <Icon
      as={BsHeart}
      color={'red.400'}
      fontSize={size}
      onClick={() => handleBookmarkChange(bookmarkParams, 'ADD')}
      cursor={'pointer'}
    />
  );

  return <>{bookmarkContextView}</>;
};
